import { TeamCalendarEntryStatus } from "@redotech/redo-team-calendar-common/team-calendar-entry-status";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const agentCalendarPromotionSchema = z.object({
  details: z.string().nullish(),
  /** Set when the homepage scraper found this promotion, not the merchant. */
  detection: z
    .object({ sourceUrl: z.string(), discountCode: z.string().nullish() })
    .nullish(),
});

const agentCalendarEventSchema = z.object({
  id: z.string(),
  title: z.string(),
  status: z.enum(TeamCalendarEntryStatus),
  timing: z.string(),
  description: z.string().nullish(),
  promotions: z.array(agentCalendarPromotionSchema),
});

export type AgentCalendarEvent = z.infer<typeof agentCalendarEventSchema>;

/** The brand calendar events in the agent's prompt, so reviewers can check its claims. */
export const getRecoverAgentCalendarEvents = {
  name: "getRecoverAgentCalendarEvents" as const,
  input: z.object({
    teamId: zExt.objectId(),
    /** When the agent drafted; the calendar window and statuses are computed at this time. */
    asOf: z.date().optional(),
  }),
  output: z.object({ events: z.array(agentCalendarEventSchema) }),
};
